function ItemIcon({ color = '#959FAF', size = '18', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83333 4.83333H4.84167M4.83333 1.5H9C9.42667 1.5 9.85333 1.6625 10.1783 1.98833L16.0117 7.82167C16.3241 8.13421 16.4996 8.55806 16.4996 9C16.4996 9.44194 16.3241 9.86579 16.0117 10.1783L10.1783 16.0117C9.86579 16.3241 9.44194 16.4996 9 16.4996C8.55806 16.4996 8.13421 16.3241 7.82167 16.0117L1.98833 10.1783C1.83334 10.0238 1.71041 9.8401 1.6266 9.63789C1.5428 9.43567 1.49977 9.21889 1.5 9V4.83333C1.5 3.94928 1.85119 3.10143 2.47631 2.47631C3.10143 1.85119 3.94928 1.5 4.83333 1.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ItemIcon;
